//const address = "http:/ / homeapi.test .91 yunshi.com / "; // 测试
const address = "http://homeapi.source.91yunshi.com/"; //正式


const config = {
    address: address,
    api: {
        bannerlist: address + "webBanner", //轮播图接口
        gettree: address + "site/tree", //站点Api
        getexam: address + "article/homeArticleOne/exam", //招考信息

        getinfo: address + "article/info", //文章详情
        gethomeExamCalendar: address + "article/homeExamCalendar", //首页考试日历 - 根据站点模块查询(不分页)
        getguide: address + "article/homeArticleOne/guide", //必考指南
        getwebTeacher: address + "webTeacher", // 获取官网老师简介列表
        getwebTeacherInfo: address + "webTeacher/", // 老师详情
        getadvisory: address + "article/homeArticleOne/advisory", //云师资讯
        getmodule: address + "module", //获取模块

        getarticlePage: address + "article/articlePage", //更多招考信息

        getexamType: address + "module/examType", // 获取考试类型
        getmoduletree: address + "module/tree", //模块列表(树结构

        getCalendar: address + "article/examCalendarPage", //考试日列更多
        getclassType: address + "classType", //课程体系

        getclassTypeinfo: address + "classType/classId/", //课程体系详情
        getsearch: address + "article/search", //文章搜索

    }
};


export default config;


// WEBPACK FOOTER //
// ./src/api/config.js